<template>
  <RootSystemGate>
    <div class="vx-col w-full mb-base flex">
      <vs-tabs
        :position="isSmallerScreen ? 'top' : 'left'"
        class="tabs-shadow-none"
        id="profile-tabs"
        :key="isSmallerScreen"
      >
        <vs-tab
          icon-pack="feather"
          icon="icon-settings"
          :label="!isSmallerScreen ? 'ตั้งค่าระบบ' : ''"
        >
          <SystemSettings />
        </vs-tab>
        <vs-tab
          icon-pack="feather"
          icon="icon-settings"
          :label="!isSmallerScreen ? 'ตั้งค่าข้อมูลบริษัท' : ''"
        >
          <CompanySettings />
        </vs-tab>
        <vs-tab
          icon-pack="feather"
          icon="icon-settings"
          :label="!isSmallerScreen ? 'ตั้งค่าผู้มีอำนาจลงนาม' : ''"
        >
          <SignerSettings />
        </vs-tab>
      </vs-tabs>
    </div>
  </RootSystemGate>
</template>

<script>
import RootSystemGate from '../RootSystemGate.vue'
import SystemSettings from '@/views/pages/System/Config/Components/SystemSettings.vue'
import CompanySettings from '@/views/pages/System/Config/Components/CompanySettings.vue'
import SignerSettings from '@/views/pages/System/Config/Components/SignerSettings.vue'
import { ValidationProvider } from 'vee-validate'
import { createNamespacedHelpers } from 'vuex'

const { mapState: mapSystemState } = createNamespacedHelpers('System')

export default {
  components: {
    RootSystemGate,
    CompanySettings,
    SystemSettings,
    SignerSettings,
    ValidationProvider,
    // vSelect
  },
  computed: {
    ...mapSystemState(['status']),
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768
    },
  },
  watch: {
    status: {
      handler(res) {
        if (res.processing !== null) {
          if (res.processing) {
            this.$vs.loading()
          } else {
            this.$vs.loading.close()
          }
        }
        if (res.success !== null) {
          this.$vs.notify({ ...res.success })
        } else if (res.error !== null) {
          this.$vs.notify({ ...res.error })
        }
      },
      deep: true,
    },
  },
}
</script>
